var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[_c('NoContent',{attrs:{"exciting":"","height":140,"width":140,"message":_vm.$t('descriptions.imbalanceNoErrors')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }